import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Box, Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../components/TableContent';

interface SkeletonItemMobileProps {}

export const SkeletonItemMobile: React.FC<SkeletonItemMobileProps> = () => {
  return (
    <TableContent direction="column" space={Spacing['inline.xxxs']}>
      <HStack justifyContent="space-between" w="full">
        <VStack space={Spacing['stack.quarck']} flex={1}>
          <Skeleton
            w="40%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <HStack space={Spacing['inline.nano']} alignItems="center">
          <Skeleton
            w={Spacing['inline.xxs']}
            h={Spacing['inline.xxs']}
            borderRadius={BoxRadius.circular}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            flex={1}
            maxW="80px"
            w="80px"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </HStack>
      <Box h="0.5px" w="full" bg="neutral.lightest" />
      <VStack space={Spacing['stack.nano']} w="full">
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            maxW="82px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            maxW="80px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            maxW="42px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            maxW="80px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            maxW="42px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            maxW="33px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            maxW="42px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            maxW="33px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
        <HStack space={Spacing['stack.quarck']} flex={1} justifyContent="space-between">
          <Skeleton
            maxW="95px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            maxW="95px"
            w="full"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </HStack>
      </VStack>
      <Box h="0.5px" w="full" bg="neutral.lightest" />
      <HStack
        space={Spacing['stack.quarck']}
        alignItems="center"
        w="full"
        justifyContent="space-between">
        <VStack space={Spacing['stack.nano']} flex={1}>
          <Skeleton
            maxW="110px"
            w="full"
            h={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
          <Skeleton
            maxW="120px"
            w="full"
            h={Typography['fontsize.xl']}
            borderRadius={BoxRadius.sm}
            endColor={Color['brand.primary.lightest']}
          />
        </VStack>
        <IconButton
          isDisabled
          testId="arrow-right"
          icon="ArrowRight"
          iconColor={Color['neutral.light']}
        />
      </HStack>
    </TableContent>
  );
};
